// 2023 Topps Star Wars Obi-Wan Kenobi — the Disney+ series set (hobby tins,
// Collector's Hobby 2-tin boxes, retail blasters; hobby/blaster released
// May 31, 2023, Collector's Hobby June 9, 2023).
// Cards from the official Topps checklist PDF (2023StarWarsObiWanChecklist.pdf,
// verbatim); parallels and odds from Cardboard Connection (counts agree with the
// PDF on every section).
// Hobby/Collector's: 8 cards per pack, 7 packs per tin; 1 auto or sketch per tin
// (Collector's adds an exclusive Oversized Original Art Reprint per box).
// Blaster: 6 cards × 10 packs, 1 manufactured relic per box; Manufactured Patch
// cards are BLASTER-EXCLUSIVE (1:11) and their /50 tier is BRONZE, not Orange.
// Verbatim PDF text kept on purpose — do not "fix":
//  - SFR-4/SFR-5 are the ONLY Sourced Fabric Relics; SFR-1..3 were never released
//    (Cardboard Connection agrees — 2 cards only).
//  - TA-HRC credits Crispian Belfrage as "Star Destroyer Captain" while his
//    single auto A-CB says "Devastator Captain" — both as printed.
//  - Droid capitalization varies: D-3 "NED-B" / MP-1 "NED-B" vs A-DCE "Ned-B".
//  - Freck signs twice: A-JR John Rosengrant (creature performer) and A-ZB
//    Zach Braff (voice).
// Black Metal Variations (DVMI/HM) are serial /5 with no further parallels —
// unnamed base slot carries the print run. Duals /25, triples /5 likewise.
// SKETCHES: standard + shaped sketch cards, 1 auto-or-sketch per tin; Topps
// never published an artist roster — two generic rows, same as 2023 Chrome.

const BASE_P = [
  {id:"blue",name:"Blue",print_run:null,color:"#4d9fff"},
  {id:"purple",name:"Purple",print_run:null,color:"#b060ff"},
  {id:"red",name:"Red",print_run:99,color:"#ff5d5d"},
  {id:"green",name:"Green",print_run:75,color:"#00e676"},
  {id:"orange",name:"Orange",print_run:50,color:"#ff9d52"},
  {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
  {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
  {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
  {id:"printing-plates",name:"Printing Plates",print_run:1,color:"#b0b0b8"},
];

const INSERT_P = [
  {id:"red",name:"Red",print_run:99,color:"#ff5d5d"},
  {id:"green",name:"Green",print_run:75,color:"#00e676"},
  {id:"orange",name:"Orange",print_run:50,color:"#ff9d52"},
  {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
  {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
  {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
  {id:"printing-plates",name:"Printing Plates",print_run:1,color:"#b0b0b8"},
];

const AUTO_P = [
  {id:"purple",name:"Purple",print_run:199,color:"#b060ff"},
  {id:"red",name:"Red",print_run:99,color:"#ff5d5d"},
  {id:"green",name:"Green",print_run:75,color:"#00e676"},
  {id:"orange",name:"Orange",print_run:50,color:"#ff9d52"},
  {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
  {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
  {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
  {id:"printing-plates",name:"Printing Plates",print_run:1,color:"#b0b0b8"},
];

export const SETS = [
  {
    id: "base", type: "base", title: "BASE SET — 100 CARDS",
    parallels: BASE_P,
    cards: [
      {n:"1", name:"Obi-Wan Kenobi", artist:null},
      {n:"2", name:"The Third Sister", artist:null},
      {n:"3", name:"Darth Vader", artist:null},
      {n:"4", name:"An Ominous Ship Approaches", artist:null},
      {n:"5", name:"The Inquisitor's Arrival", artist:null},
      {n:"6", name:"The Grand Inquisitor", artist:null},
      {n:"7", name:"A Hidden Jedi Among Them", artist:null},
      {n:"8", name:"Buying a Toy from Teeka", artist:null},
      {n:"9", name:"Leia Organa and L0LA", artist:null},
      {n:"10", name:"L0LA Among the Treetops", artist:null},
      {n:"11", name:"Owen Lars", artist:null},
      {n:"12", name:"Reva Confronts Owen Lars", artist:null},
      {n:"13", name:"The Fifth Brother", artist:null},
      {n:"14", name:"\"Stand down, Third Sister. Now!\"", artist:null},
      {n:"15", name:"Obi-Wan Kenobi & Owen Lars", artist:null},
      {n:"16", name:"The Organa Family", artist:null},
      {n:"17", name:"\"There are many ways to lead. You just have to find yours.\"", artist:null},
      {n:"18", name:"Bail Organa Visits an Old Ally", artist:null},
      {n:"19", name:"The Third Sister Orchestrates Leia's Kidnapping", artist:null},
      {n:"20", name:"A Clone Trooper Veteran", artist:null},
      {n:"21", name:"Obi-Wan Incognito", artist:null},
      {n:"22", name:"Haja Helps a Mother and Son off Daiyu", artist:null},
      {n:"23", name:"Haja Estree, Noble \"Jedi\"", artist:null},
      {n:"24", name:"Obi-Wan Kenobi Focuses on the Investigation", artist:null},
      {n:"25", name:"Vect Nokru", artist:null},
      {n:"26", name:"The Princess Imprisoned!", artist:null},
      {n:"27", name:"The Imposing Third Sister", artist:null},
      {n:"28", name:"The Fourth Sister on Daiyu", artist:null},
      {n:"29", name:"The Fifth Brother on Daiyu", artist:null},
      {n:"30", name:"A Former Master in the Shadows", artist:null},
      {n:"31", name:"The Fifth Brother's Legion of Stormtroopers", artist:null},
      {n:"32", name:"Perched Above the Streets of Daiyu", artist:null},
      {n:"33", name:"A Con Artist with a Good Heart", artist:null},
      {n:"34", name:"\"You can't escape him, Obi-Wan!\"", artist:null},
      {n:"35", name:"Darth Vader Awakens", artist:null},
      {n:"36", name:"A Quiet Moment for Obi-Wan", artist:null},
      {n:"37", name:"The Fearsome Helmet of Darth Vader", artist:null},
      {n:"38", name:"Fortress Vader", artist:null},
      {n:"39", name:"Walking across the Mapuzo Desert", artist:null},
      {n:"40", name:"Visions of Anakin", artist:null},
      {n:"41", name:"Freck", artist:null},
      {n:"42", name:"A Probe Droid Investigates", artist:null},
      {n:"43", name:"The Inquisitors Strategize", artist:null},
      {n:"44", name:"Illuminated by His Lightsaber", artist:null},
      {n:"45", name:"Tala Durith", artist:null},
      {n:"46", name:"Tala & Leia", artist:null},
      {n:"47", name:"Old Allies Clash!", artist:null},
      {n:"48", name:"Stand-off in the Quarry", artist:null},
      {n:"49", name:"Darth Vader Ignites the Battleground", artist:null},
      {n:"50", name:"Vader Amongst the Flames", artist:null},
      {n:"51", name:"Kenobi Defeated", artist:null},
      {n:"52", name:"A Shadowy Figure Approaches", artist:null},
      {n:"53", name:"Obi-Wan in the Bacta Tank", artist:null},
      {n:"54", name:"The Menacing Darth Vader", artist:null},
      {n:"55", name:"Obi-Wan Arrives on Jabiim", artist:null},
      {n:"56", name:"Kawlan Roken", artist:null},
      {n:"57", name:"Obi-Wan's New Allies Plan Their Attack", artist:null},
      {n:"58", name:"An Underwater Approach", artist:null},
      {n:"59", name:"L0LA Sneaks Aboard", artist:null},
      {n:"60", name:"Evading the Security Droids", artist:null},
      {n:"61", name:"Fortress Inquisitorius' Dark Secrets", artist:null},
      {n:"62", name:"Obi-Wan Discovers the Jedi Tomb", artist:null},
      {n:"63", name:"Kenobi on the Offensive!", artist:null},
      {n:"64", name:"Obi-Wan Holds the Ocean at Bay", artist:null},
      {n:"65", name:"The Inquisitors Approach", artist:null},
      {n:"66", name:"Leia Stays Hidden", artist:null},
      {n:"67", name:"The Third Sister and Her Purge Troopers", artist:null},
      {n:"68", name:"Inquisitors at Odds", artist:null},
      {n:"69", name:"Darth Vader Arrives on Nur", artist:null},
      {n:"70", name:"The Rebels Mourn Wade", artist:null},
      {n:"71", name:"Leia Rescued", artist:null},
      {n:"72", name:"Obi-Wan Stands Ready", artist:null},
      {n:"73", name:"Darth Vader Aboard His Star Destroyer", artist:null},
      {n:"74", name:"Reva Becomes Grand Inquisitor", artist:null},
      {n:"75", name:"Awaiting the Empire's Arrival", artist:null},
      {n:"76", name:"Master & Apprentice", artist:null},
      {n:"77", name:"The Imperial Siege", artist:null},
      {n:"78", name:"Padawan Reva's Terrifying Encounter", artist:null},
      {n:"79", name:"Obi-Wan Apprehended", artist:null},
      {n:"80", name:"Leia Removes L0LA's Restraining Bolt", artist:null},
      {n:"81", name:"Escape from Vader's Clutches!", artist:null},
      {n:"82", name:"Anakin Skywalker", artist:null},
      {n:"83", name:"Showdown with the Dark Lord!", artist:null},
      {n:"84", name:"The Return of the Grand Inquisitor", artist:null},
      {n:"85", name:"Leia & Obi-Wan Part Ways", artist:null},
      {n:"86", name:"Beru Lars in the Homestead", artist:null},
      {n:"87", name:"Owen & Beru Lars Prepare for Attack", artist:null},
      {n:"88", name:"The Devastator Tails Obi-Wan's Ship", artist:null},
      {n:"89", name:"Obi-Wan's Battle Stance", artist:null},
      {n:"90", name:"The Dark Lord, Ready to Duel!", artist:null},
      {n:"91", name:"Obi-Wan at Full Strength", artist:null},
      {n:"92", name:"The Scarred Visage of Darth Vader", artist:null},
      {n:"93", name:"The Emperor", artist:null},
      {n:"94", name:"Leia is Reunited with L0LA", artist:null},
      {n:"95", name:"Leia Embraces the Jedi Master", artist:null},
      {n:"96", name:"Visiting the Lars Homestead", artist:null},
      {n:"97", name:"Meeting Luke Skywalker", artist:null},
      {n:"98", name:"Obi-Wan Kenobi, Jedi Master", artist:null},
      {n:"99", name:"The Return of an Old Friend", artist:null},
      {n:"100", name:"Qui-Gon Jinn", artist:null},
    ]
  },
  {
    id: "heroes", type: "insert", title: "HEROES — 10 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"H-1", name:"Owen Lars", artist:null},
      {n:"H-2", name:"Princess Leia Organa", artist:null},
      {n:"H-3", name:"Obi-Wan Kenobi", artist:null},
      {n:"H-4", name:"Bail Organa", artist:null},
      {n:"H-5", name:"Haja Estree", artist:null},
      {n:"H-6", name:"Tala Durith", artist:null},
      {n:"H-7", name:"Kawlan Roken", artist:null},
      {n:"H-8", name:"Sully Stark", artist:null},
      {n:"H-9", name:"Beru Lars", artist:null},
      {n:"H-10", name:"Luke Skywalker", artist:null},
    ]
  },
  {
    id: "darth-vader-and-the-inquisitorius", type: "insert", title: "DARTH VADER AND THE INQUISITORIUS — 5 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"DVI-1", name:"The Grand Inquisitor", artist:null},
      {n:"DVI-2", name:"Darth Vader", artist:null},
      {n:"DVI-3", name:"Reva", artist:null},
      {n:"DVI-4", name:"Fifth Brother", artist:null},
      {n:"DVI-5", name:"Fourth Sister", artist:null},
    ]
  },
  {
    id: "concept-art", type: "insert", title: "CONCEPT ART — 10 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"CA-1", name:"Chapter 1", artist:null},
      {n:"CA-2", name:"Chapter 1", artist:null},
      {n:"CA-3", name:"Chapter 1", artist:null},
      {n:"CA-4", name:"Chapter 1", artist:null},
      {n:"CA-5", name:"Chapter 2", artist:null},
      {n:"CA-6", name:"Chapter 2", artist:null},
      {n:"CA-7", name:"Chapter 2", artist:null},
      {n:"CA-8", name:"Chapter 3", artist:null},
      {n:"CA-9", name:"Chapter 4", artist:null},
      {n:"CA-10", name:"Chapter 4", artist:null},
    ]
  },
  {
    id: "droids", type: "insert", title: "DROIDS — 5 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"D-1", name:"L0LA", artist:null},
      {n:"D-2", name:"1-JAC", artist:null},
      {n:"D-3", name:"NED-B", artist:null},
      {n:"D-4", name:"Probe Droid", artist:null},
      {n:"D-5", name:"ID-9 Seeker Droid", artist:null},
    ]
  },
  {
    id: "creatures-and-aliens", type: "insert", title: "CREATURES AND ALIENS — 10 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"CAA-1", name:"Supply Store Clerk", artist:null},
      {n:"CAA-2", name:"Freck", artist:null},
      {n:"CAA-3", name:"Teeka", artist:null},
      {n:"CAA-4", name:"Eopie", artist:null},
      {n:"CAA-5", name:"The Butcher of Brix", artist:null},
      {n:"CAA-6", name:"Borrim Shub", artist:null},
      {n:"CAA-7", name:"Tredgar Volk", artist:null},
      {n:"CAA-8", name:"Sweebotta", artist:null},
      {n:"CAA-9", name:"Grelli Cryko", artist:null},
      {n:"CAA-10", name:"Agira", artist:null},
    ]
  },
  {
    id: "dvi-black-metal", type: "insert", title: "DARTH VADER AND THE INQUISITORIUS BLACK METAL VARIATION — 5 CARDS",
    parallels: [
      {id:"base",name:"",print_run:5,color:"#a8a8b4"},
    ],
    cards: [
      {n:"DVMI-1", name:"The Grand Inquisitor", artist:null},
      {n:"DVMI-2", name:"Darth Vader", artist:null},
      {n:"DVMI-3", name:"Reva", artist:null},
      {n:"DVMI-4", name:"Fifth Brother", artist:null},
      {n:"DVMI-5", name:"Fourth Sister", artist:null},
    ]
  },
  {
    id: "heroes-black-metal", type: "insert", title: "HEROES BLACK METAL VARIATION — 10 CARDS",
    parallels: [
      {id:"base",name:"",print_run:5,color:"#a8a8b4"},
    ],
    cards: [
      {n:"HM-1", name:"Owen Lars", artist:null},
      {n:"HM-2", name:"Princess Leia Organa", artist:null},
      {n:"HM-3", name:"Obi-Wan Kenobi", artist:null},
      {n:"HM-4", name:"Bail Organa", artist:null},
      {n:"HM-5", name:"Haja Estree", artist:null},
      {n:"HM-6", name:"Tala Durith", artist:null},
      {n:"HM-7", name:"Kawlan Roken", artist:null},
      {n:"HM-8", name:"Sully Stark", artist:null},
      {n:"HM-9", name:"Beru Lars", artist:null},
      {n:"HM-10", name:"Luke Skywalker", artist:null},
    ]
  },
  {
    id: "oversized-original-art-reprints", type: "insert", title: "OVERSIZED ORIGINAL ART REPRINTS — 10 CARDS",
    parallels: [],
    cards: [
      {n:"OAR-1", name:"Kenobi on Tatooine", artist:null},
      {n:"OAR-2", name:"Reva", artist:null},
      {n:"OAR-3", name:"Fifth Brother", artist:null},
      {n:"OAR-4", name:"The Wrath of the Inquisitors", artist:null},
      {n:"OAR-5", name:"Fourth Sister", artist:null},
      {n:"OAR-6", name:"Darth Vader and his Inquisitors", artist:null},
      {n:"OAR-7", name:"The Grand Inquisitor", artist:null},
      {n:"OAR-8", name:"Obi-Wan Kenobi", artist:null},
      {n:"OAR-9", name:"Duel of former Master and Apprentice", artist:null},
      {n:"OAR-10", name:"Good vs Evil", artist:null},
    ]
  },
  {
    id: "original-art-insert-sized-reprints", type: "insert", title: "ORIGINAL ART INSERT SIZED REPRINT — 10 CARDS",
    parallels: INSERT_P,
    cards: [
      {n:"OAI-1", name:"Kenobi on Tatooine", artist:null},
      {n:"OAI-2", name:"Reva", artist:null},
      {n:"OAI-3", name:"Fifth Brother", artist:null},
      {n:"OAI-4", name:"The Wrath of the Inquisitors", artist:null},
      {n:"OAI-5", name:"Fourth Sister", artist:null},
      {n:"OAI-6", name:"Darth Vader and his Inquisitors", artist:null},
      {n:"OAI-7", name:"The Grand Inquisitor", artist:null},
      {n:"OAI-8", name:"Obi-Wan Kenobi", artist:null},
      {n:"OAI-9", name:"Duel of former Master and Apprentice", artist:null},
      {n:"OAI-10", name:"Good vs Evil", artist:null},
    ]
  },
  {
    id: "autographs", type: "auto", title: "AUTOGRAPHS — 25 CARDS",
    parallels: AUTO_P,
    cards: [
      {n:"A-BP", name:"Bonnie Piesse", artist:"Beru Lars"},
      {n:"A-BS", name:"Benny Safdie", artist:"Nari"},
      {n:"A-CB", name:"Crispian Belfrage", artist:"Devastator Captain"},
      {n:"A-DC", name:"Dan Considine", artist:"Deck Officer Densin Clord"},
      {n:"A-DCE", name:"Dustin Ceithamer", artist:"Ned-B"},
      {n:"A-EW", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"A-GF", name:"Gabe Fonseca", artist:"Duke Kayo Organa"},
      {n:"A-GFE", name:"Grant Feely", artist:"Luke Skywalker"},
      {n:"A-HC", name:"Hayden Christensen", artist:"Darth Vader"},
      {n:"A-HM", name:"Heath McGough", artist:"Foreman Groff Ditcher"},
      {n:"A-II", name:"Ian Inigo", artist:"Cousin Niano Organa"},
      {n:"A-IM", name:"Ian McDiarmid", artist:"Emperor Palpatine"},
      {n:"A-IV", name:"Indira Varma", artist:"Tala Durith"},
      {n:"A-JR", name:"John Rosengrant", artist:"Freck"},
      {n:"A-JS", name:"Jecobi Swain", artist:"Jayco"},
      {n:"A-MI", name:"Moses Ingram", artist:"Reva"},
      {n:"A-MM", name:"Molly Miller", artist:"Handmaiden Agira"},
      {n:"A-RK", name:"Rya Kihlstedt", artist:"Fourth Sister"},
      {n:"A-RM", name:"Ryder McLaughlin", artist:"Wade Resselian"},
      {n:"A-RP", name:"Rupert Friend", artist:"The Grand Inquisitor"},
      {n:"A-RS", name:"Roberta Sparta", artist:"Duchess Celly Organa"},
      {n:"A-SK", name:"Simone Kessell", artist:"Breha Organa"},
      {n:"A-TM", name:"Temuera Morrison", artist:"Veteran Clone Trooper"},
      {n:"A-VLB", name:"Vivien Lyra Blair", artist:"Princess Leia Organa"},
      {n:"A-ZB", name:"Zach Braff", artist:"Freck"},
    ]
  },
  {
    id: "dual-autographs", type: "auto", title: "DUAL AUTOGRAPHS — 14 CARDS",
    parallels: [
      {id:"base",name:"",print_run:25,color:"#4d9fff"},
      {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
      {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
    ],
    cards: [
      {n:"DA-BG", name:"Bonnie Piesse / Grant Feely", artist:"Beru Lars / Luke Skywalker"},
      {n:"DA-DI", name:"Dustin Ceithamer / Indira Varma", artist:"Ned-B / Tala Durith"},
      {n:"DA-DV", name:"Dustin Ceithamer / Vivien Lyra Blair", artist:"Ned-B / Princess Leia Organa"},
      {n:"DA-EH", name:"Hayden Christensen / Ewan McGregor", artist:"Darth Vader / Obi-Wan Kenobi"},
      {n:"DA-EI", name:"Ewan McGregor / Indira Varma", artist:"Obi-Wan Kenobi / Tala Durith"},
      {n:"DA-ET", name:"Ewan McGregor / Temuera Morrison", artist:"Obi-Wan Kenobi / Veteran Clone Trooper"},
      {n:"DA-EZ", name:"Zach Braff / Ewan McGregor", artist:"Freck / Obi-Wan Kenobi"},
      {n:"DA-GR", name:"Gabe Fonseca / Roberta Sparta", artist:"Duke Kayo Organa / Duchess Celly Organa"},
      {n:"DA-HR", name:"Hayden Christensen / Rupert Friend", artist:"Darth Vader / The Grand Inquisitor"},
      {n:"DA-KF", name:"Rya Kihlstedt / Rupert Friend", artist:"Fourth Sister / The Grand Inquisitor"},
      {n:"DA-MR", name:"Rya Kihlstedt / Moses Ingram", artist:"Fourth Sister / Reva"},
      {n:"DA-RM", name:"Rupert Friend / Moses Ingram", artist:"The Grand Inquisitor / Reva"},
      {n:"DA-VG", name:"Grant Feely / Vivien Lyra Blair", artist:"Luke Skywalker / Princess Leia Organa"},
      {n:"DA-VS", name:"Simone Kessell / Vivien Lyra Blair", artist:"Breha Organa / Princess Leia Organa"},
    ]
  },
  {
    id: "triple-autographs", type: "auto", title: "TRIPLE AUTOGRAPHS — 6 CARDS",
    parallels: [
      {id:"base",name:"",print_run:5,color:"#4d9fff"},
      {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
    ],
    cards: [
      {n:"TA-EHI", name:"Hayden Christensen / Ewan McGregor / Ian McDiarmid", artist:"Darth Vader / Obi-Wan Kenobi / Emperor Palpatine"},
      {n:"TA-GRI", name:"Roberta Sparta / Gabe Fonseca / Ian Inigo", artist:"Duchess Celly Organa / Duke Kayo Organa / Cousin Niano Organa"},
      {n:"TA-HRC", name:"Hayden Christensen / Rupert Friend / Crispian Belfrage", artist:"Darth Vader / The Grand Inquisitor / Star Destroyer Captain"},
      {n:"TA-HRM", name:"Rupert Friend / Hayden Christensen / Moses Ingram", artist:"The Grand Inquisitor / Darth Vader / Reva"},
      {n:"TA-IVD", name:"Vivien Lyra Blair / Indira Varma / Dustin Ceithamer", artist:"Princess Leia Organa / Tala Durith / Ned-B"},
      {n:"TA-MIV", name:"Indira Varma / Vivien Lyra Blair / Moses Ingram", artist:"Tala Durith / Princess Leia Organa / Reva"},
    ]
  },
  {
    id: "sourced-fabric-relics", type: "insert", title: "SOURCED FABRIC RELICS — 2 CARDS",
    parallels: [
      {id:"base",name:"",print_run:99,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:75,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:50,color:"#ff9d52"},
      {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
      {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
      {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
    ],
    cards: [
      {n:"SFR-4", name:"Tala Durith", artist:null},
      {n:"SFR-5", name:"Reva", artist:null},
    ]
  },
  {
    id: "coin-medallions", type: "insert", title: "COMMEMORATIVE CHARACTER COIN MEDALLIONS — 5 CARDS",
    parallels: [
      {id:"base",name:"",print_run:50,color:"#4d9fff"},
      {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
      {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
      {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
    ],
    cards: [
      {n:"CM-1", name:"Obi-Wan Kenobi", artist:null},
      {n:"CM-2", name:"Darth Vader", artist:null},
      {n:"CM-3", name:"Princess Leia Organa", artist:null},
      {n:"CM-4", name:"Reva", artist:null},
      {n:"CM-5", name:"The Grand Inquisitor", artist:null},
    ]
  },
  {
    id: "manufactured-patches", type: "insert", title: "MANUFACTURED PATCH CARDS — 17 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:99,color:"#ff5d5d"},
      {id:"green",name:"Green",print_run:75,color:"#00e676"},
      {id:"bronze",name:"Bronze",print_run:50,color:"#d4a855"},
      {id:"silver",name:"Silver",print_run:25,color:"#d4d4dc"},
      {id:"gold",name:"Gold",print_run:10,color:"#f0c040"},
      {id:"black",name:"Black",print_run:1,color:"#a8a8b4"},
    ],
    cards: [
      {n:"MP-1", name:"NED-B", artist:null},
      {n:"MP-2", name:"Darth Vader & His Inquisitors", artist:null},
      {n:"MP-3", name:"Inquisitors & Purge Troopers", artist:null},
      {n:"MP-4", name:"Reva & Purge Troopers", artist:null},
      {n:"MP-5", name:"Old Allies Clash!", artist:null},
      {n:"MP-6", name:"Obi-Wan Kenobi", artist:null},
      {n:"MP-7", name:"Darth Vader", artist:null},
      {n:"MP-8", name:"Obi-Wan Kenobi Stands Guard", artist:null},
      {n:"MP-9", name:"The Dark Lord", artist:null},
      {n:"MP-10", name:"Kenobi Up Close", artist:null},
      {n:"MP-11", name:"Obi-Wan Vs Darth Vader", artist:null},
      {n:"MP-12", name:"Stormtrooper", artist:null},
      {n:"MP-13", name:"Grand Inquisitor", artist:null},
      {n:"MP-14", name:"Reva & Purge Troopers 2", artist:null},
      {n:"MP-15", name:"The Grand Inquisitor 2", artist:null},
      {n:"MP-16", name:"Reva", artist:null},
      {n:"MP-17", name:"The Inquisitorius", artist:null},
    ]
  },
  {
    id: "sketch", type: "sketch", title: "SKETCH CARDS",
    parallels: [],
    cards: [
      {n:"SK-1", name:"Sketch Card", artist:"Various Artists"},
      {n:"SK-2", name:"Shaped Sketch Card", artist:"Various Artists"},
    ]
  },
];
